import { CheckCheck } from 'lucide-react';
import React from 'react';

import { Notification } from '../../types/notification';
import { Button } from '../ui/button';
import { ScrollArea } from '../ui/scroll-area';

import { NotificationList } from './NotificationList';

interface NotificationCenterProps {
  notifications: Notification[];
  onMarkAllRead: () => void;
  onAction: (notification: Notification, handlerId: string) => void;
}

export const NotificationCenter: React.FC<NotificationCenterProps> = ({
  notifications,
  onMarkAllRead,
  onAction,
}) => {
  return (
    <div className='flex flex-col h-full'>
      <div className='flex items-center justify-between py-4 border-b'>
        <h2 className='text-lg font-semibold'>Notifications</h2>
        {notifications.some(n => !n.read) && (
          <Button
            variant='ghost'
            size='sm'
            onClick={onMarkAllRead}
            className='text-xs text-muted-foreground hover:text-primary'
          >
            <CheckCheck className='mr-2 h-3 w-3' />
            Mark all read
          </Button>
        )}
      </div>

      <ScrollArea className='flex-1 -mx-6 px-6'>
        <div className='py-4'>
          {notifications.length === 0 ? (
            <div className='flex flex-col items-center justify-center py-12 text-center text-muted-foreground'>
              <p>No notifications</p>
            </div>
          ) : (
            <NotificationList
              notifications={notifications}
              onAction={onAction}
            />
          )}
        </div>
      </ScrollArea>
    </div>
  );
};
